@use "variables" as *;

.rightContainer {
  height: 100%;
  width: 100%;
  margin-top: $spacing-m;
  margin-right: $spacing-s;
}

.name {
  font-size: $fontSize-s;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.defaultIcon {
  display: flex;
  height: 50px;
  width: 70px;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  align-items: center;
  justify-content: center;
  border-radius: 16px !important;
}

.shortName {
  font-size: $fontSize-xs;
  font-weight: normal;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
